import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { SearchRequest, SeedTreatmentSearchRequest, TankmixTest } from '../models/searchRequest';
import { TankmixRequest } from '../models/tankmixRequest';
import { APIPortResolver } from 'src/environments/APIPortResolver';
@Injectable({
  providedIn: 'root'
})
export class HelenaApiService {
  apiPath: string;
  fixedProductSetCode = '89';
  constructor(private http: HttpClient) { 
    this.apiPath=APIPortResolver.resolve()+'helena/';
  
  }

  getLanguages() {
    return this.http.get(this.apiPath + 'languages');
  }
  getActiveIngredients() {
    return this.http.get(this.apiPath + 'active-ingredients');
  }
  getYaraProducts() {
  
    return this.http.get(this.apiPath + 'productsByProductSet/' + this.fixedProductSetCode);
  }
  getOutcome(tankmixId: string): Observable<TankmixTest> {
    return this.http.get<TankmixTest>(this.apiPath + 'outcome/' + tankmixId);
  }
  getagrochemicals() {
    return this.http.get(this.apiPath + 'agrochemicals');
  }
  search(searchRequest: SearchRequest): Observable<TankmixTest[]> {
    return this.http.post<TankmixTest[]>(this.apiPath + 'search', searchRequest);
  }
  searchSeedTreatments(searchRequest: SeedTreatmentSearchRequest): Observable<TankmixTest[]> {
    return this.http.post<TankmixTest[]>(this.apiPath + 'seed-search', searchRequest)
     
    ;
  }
  submitRequest(tankmixRequest: TankmixRequest, html: string) {
    return this.http.post(this.apiPath + 'tankmix-request',
      {
        html,
        json: JSON.stringify(tankmixRequest),
        requestor: tankmixRequest.email
      },
    )
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }
}
